/* file description */


import { Modal as MobileModal } from 'antd-mobile';

const MOBILE_REG = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i;

export const isMobileEnv = () => {
  const widthMobile = window.matchMedia('only screen and (max-width: 500px)').matches;

  return widthMobile || !!navigator.userAgent.match(MOBILE_REG);
};


export const clearMobileModal = () => {
  const isMobile = isMobileEnv();
  isMobile && MobileModal.clear();
};
